import { SeatFlatAngledIcon } from './SeatFlatAngledIcon';

/**
 * author: Google
 * id 22BC78FF-895C-497C-B6F0-143F60901C20
 * name seat-flat-angled
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/seat-flat-angled.svg
 * tags
 */
export const AirlineSeatFlatAngledIcon = SeatFlatAngledIcon;
export default AirlineSeatFlatAngledIcon